import { signUpRequested } from '@wix/bi-logger-vmaf/v2';
import React from 'react';
import biLogger from '../lib/bi/biLogger';
import { wrapComponentDisplayName } from '../lib/componentDisplayName';
import redirectToLogin from './redirectToLogin';
import { isLoggedIn } from './user';

function shouldLogin() {
  return process.env.NODE_ENV === 'production' && !isLoggedIn();
}

function withRequireLogin<P>(WrappedComponent: React.ComponentType<P>) {
  class WithRequireLogin extends React.Component<P> {
    static displayName = wrapComponentDisplayName(
      WrappedComponent,
      'withRequireLogin',
    );

    componentDidMount() {
      if (shouldLogin()) {
        void biLogger.report(signUpRequested({}));

        redirectToLogin({
          returnUrl: window.location.href,
        });
      }
    }

    render() {
      if (shouldLogin()) {
        return null;
      }

      return <WrappedComponent {...this.props} />;
    }
  }

  return WithRequireLogin;
}

export default withRequireLogin;
